const CopyRight = () => {
    return (
        <div className="w-screen bg-white py-5 border border-gray-200">
            <p className="text-base text-center text-black">
                Copyright &copy; {new Date().getFullYear()} 360Pipe All rights reserved.
            </p>
        </div>
    )
}

export default CopyRight